(() => {
  const map = window.CKB_PRODUCT_LEARNING_MAP;
  if (!map || !Array.isArray(map.profiles)) return;

  const powerArticle = {
    id: 'CKC-KA-1399',
    title: 'Understanding BALUN, UNUN, and Matching-Transformer Power Handling',
    handle: 'understanding-balun-unun-and-matching-transformer-power-handling',
    quick: 'Understand why a published wattage is a ceiling, how mismatch changes voltage/current stress, and how frequency, duty cycle, heat, tuner location, and the full antenna system determine safe power.',
    category: 'Feed Lines & RF Components',
    section: 'Matching & Isolation Devices',
    role: 'Power / Safety / Engineering',
    url: '/pages/chameleon-knowledge-base?article=understanding-balun-unun-and-matching-transformer-power-handling'
  };

  const transformerEquippedProfiles = new Set([
    'CHA LEFS 4010',
    'CHA LEFS 8010',
    'CHA LEFS FEATHER',
    'CHA MPAS Lite',
    'CHA MPAS 2.0',
    'CHA TDL',
    'CHA EMCOMM II',
    'CHA EMCOMM III Base',
    'CHA EMCOMM III Portable',
    'CHA OCF40',
    'CHA HYBRID-MINI',
    'CHA HYBRID-MICRO',
    'CHA SKYLOOP 40'
  ]);

  map.profiles.forEach(profile => {
    if (!transformerEquippedProfiles.has(profile.name) || !Array.isArray(profile.articles)) return;
    if (profile.articles.some(article => article.handle === powerArticle.handle)) return;
    profile.articles.push({ ...powerArticle });
    profile.matchingArticleCount = Number(profile.matchingArticleCount || profile.articles.length - 1) + 1;
  });

  if (!map.profiles.some(profile => profile.name === 'CHA UNUN/BALUN')) {
    map.profiles.push({
      name: 'CHA UNUN/BALUN',
      aliases: ['unun balun', 'cha unun balun', 'balun unun'],
      status: 'active',
      builderSupported: false,
      matchingArticleCount: 4,
      articles: [
        { ...powerArticle },
        {
          id: 'CKC-KA-0012',
          title: 'Balun vs. Unun: What Is the Difference?',
          handle: 'balun-vs-unun-what-is-the-difference',
          quick: 'Choose from the required balanced or unbalanced interface and complete antenna topology—not from impedance ratio alone.',
          category: 'Getting Started',
          section: 'HF Fundamentals',
          role: 'Engineering / Selection',
          url: '/pages/chameleon-knowledge-base?article=balun-vs-unun-what-is-the-difference'
        },
        {
          id: 'CKC-KA-0099',
          title: 'What Is an Impedance Transformer?',
          handle: 'what-is-an-impedance-transformer',
          quick: 'Learn what an impedance ratio does, what it does not do, and why the attached antenna still controls the actual load.',
          category: 'Getting Started',
          section: 'RF Components',
          role: 'Engineering / Fundamentals',
          url: '/pages/chameleon-knowledge-base?article=what-is-an-impedance-transformer'
        },
        {
          id: 'CKC-KA-1316',
          title: 'Transformer, Balun, Unun, and Loading-Coil Diagnosis',
          handle: 'transformer-balun-unun-and-loading-coil-diagnosis',
          quick: 'Use a controlled low-power sequence to separate transformer, connection, feed-line, loading, and antenna faults.',
          category: 'Troubleshooting',
          section: 'Foundation Library — Measurements and Troubleshooting',
          role: 'Troubleshooting / Maintenance',
          url: '/pages/chameleon-knowledge-base?article=transformer-balun-unun-and-loading-coil-diagnosis'
        }
      ]
    });
  }

  if (!map.profiles.some(profile => profile.name === 'CHA SKYLOOP 2.0')) {
    map.profiles.push({
      name: 'CHA SKYLOOP 2.0',
      aliases: ['skyloop 2.0', 'skyloop 2 0', 'cha skyloop 2.0'],
      status: 'active',
      builderSupported: false,
      matchingArticleCount: 3,
      articles: [
        { ...powerArticle },
        {
          id: 'CKC-KA-0122',
          title: 'What Is a Horizontal Loop Antenna?',
          handle: 'what-is-a-horizontal-loop-antenna',
          quick: 'Learn how a horizontal loop works and why circumference, height, geometry, and the completed feed system matter.',
          category: 'Getting Started',
          section: 'Antenna Types',
          role: 'Engineering / Selection',
          url: '/pages/chameleon-knowledge-base?article=what-is-a-horizontal-loop-antenna'
        },
        {
          id: 'CKC-KA-1316',
          title: 'Transformer, Balun, Unun, and Loading-Coil Diagnosis',
          handle: 'transformer-balun-unun-and-loading-coil-diagnosis',
          quick: 'Use a controlled low-power sequence to separate transformer, connection, feed-line, loading, and antenna faults.',
          category: 'Troubleshooting',
          section: 'Foundation Library — Measurements and Troubleshooting',
          role: 'Troubleshooting / Maintenance',
          url: '/pages/chameleon-knowledge-base?article=transformer-balun-unun-and-loading-coil-diagnosis'
        }
      ]
    });
  }
})();
